// extracted by mini-css-extract-plugin
export var addToCartButton = "_s8-b";
export var arrowButtonContainer = "_s8-9";
export var arrowButtonIcon = "_s8-a";
export var carouselArrowButton = "_s8-6";
export var carouselElementContainer = "_s8-1";
export var galleryThumbnail = "_s8-d";
export var galleryThumbnailImage = "_s8-e";
export var left = "_s8-7";
export var productDisplayCarouselContainer = "_s8-0";
export var productTileContainer = "_s8-2";
export var productTileImage = "_s8-4";
export var productTileImageContainer = "_s8-3";
export var productTileTitle = "_s8-5";
export var right = "_s8-8";
export var sliderOverflow = "_s8-c";